import { v4 as uuidv4 } from 'uuid';
import { ArrayUtil, ObjectUtil, StringUtil } from 'src/utils';

interface AccountingLinkUserLoginListItemDTO {
  id: string;
  userLogin: string;
  dataLinkLocation: string;
  comment: string;
  disabled: boolean;

}
const AccountingLinkUserLoginListItemDTO = {
  create: (initValues?: Partial<AccountingLinkUserLoginListItemDTO>): AccountingLinkUserLoginListItemDTO => {
    const defaults: AccountingLinkUserLoginListItemDTO = {
      id: '',
      userLogin: '',
      dataLinkLocation: '',
      comment: '',
      disabled: false,
    };
    const fixedInitValues: Partial<AccountingLinkUserLoginListItemDTO> = initValues != null
      ? {
        id: StringUtil.IsNullOrEmpty(initValues.id) ? uuidv4() : initValues.id,
      }
      : {};
    return { ...defaults, ...initValues, ...fixedInitValues };
  },
};

export default AccountingLinkUserLoginListItemDTO;
